const countryTaxNames: Record<string, string> = {
  SG: 'GST',
};

export interface TaxLabels {
  taxName: string;
  rate: string;
  priceExcluding: string;
  subtotalExcluding: string;
  totalExcluding: string;
  grandTotalIncluding: string;
}

export const getTaxLabels = (countryCode?: string): TaxLabels => {
  const normalizedCountryCode = countryCode?.toUpperCase() || '';
  const taxName = countryTaxNames[normalizedCountryCode] || 'VAT';

  return {
    taxName,
    rate: `${taxName} Rate`,
    priceExcluding: `Price (ex-${taxName})`,
    subtotalExcluding: `Subtotal (ex-${taxName})`,
    totalExcluding: `Total (ex-${taxName})`,
    grandTotalIncluding: `Grand Total (${taxName} inclusive)`,
  };
};
